import { Component, OnInit } from '@angular/core';
import { Category, User } from 'src/app/_models';
import { HeaderService, CatalogService, AuthenticationService } from 'src/app/_services';
import { TranslateService } from '@ngx-translate/core';
import { Router, NavigationEnd  } from '@angular/router';
import { environment } from 'src/environments/environment.prod';
import { ApplicationStateService } from 'src/app/_services/application-state.service';
import { NgxSpinner } from 'ngx-spinner/lib/ngx-spinner.enum';
import { NgxSpinnerService } from 'ngx-spinner';

declare const $ : any;

@Component({
  selector: 'app-category-nav',
  templateUrl: './category-nav.component.html',
  styleUrls: ['./category-nav.component.css']
})
export class CategoryNavComponent implements OnInit {

  public currentUser : User;
  public categories : Category[] = [];
  public featured : Category[] = [];

  public showNavigation : boolean;
  public showFeatured : boolean;
  
  constructor(
    private header: HeaderService,
    public translate : TranslateService,
    public catalog : CatalogService,
    public auth : AuthenticationService,
    public router : Router,
    public apps : ApplicationStateService,
    private spinner : NgxSpinnerService
  ) { 

    this.header.showNavigation.subscribe( s => this.showNavigation = s);
    this.header.showFeatured.subscribe( s => this.showFeatured = s);

    this.auth.currentUser.subscribe( user => {
      this.spinner.show('categoryNavSpinner');
      this.currentUser = user;
      this.catalog.getTree(auth.isLogedUser).subscribe( result => {
        this.categories = this.categories.slice(0,0).concat (this.catalog.Categories);
        this.featured = this.featured.slice(0,0).concat(this.catalog.Featured);
        setTimeout(function() { 
          $(document).trigger('initNavigation');
        }, environment.READY_TIMEOUT); 
        this.spinner.hide('categoryNavSpinner');
      });
    });
    
     this.router.events.subscribe( e => {
       if(e instanceof NavigationEnd){
            setTimeout(function() { 
              $(document).trigger('initNavigation');
            }, environment.READY_TIMEOUT); 
        }
     });

  }

  ngOnInit() {
  }

}
